import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AuthorityType } from '../../model/user/authority-type.enum';
import { NecAuthService } from '../../service/auth/auth.service';
import { NecDictDataService } from '../../service/dict-data/dict-data.service';
import { NecLocalStorageService } from '../../service/localStorage/local-storage.service';
import { NecToast } from '../../service/toast/toast.service';
import { UserService } from '../../service/user/user.service';
import { HeaderDropdownMenu } from './header-dropdown-menu';
import { HeaderMenu } from './header-menu';
import { HeaderService } from './header.service';
import { NecTenantAdminAccountInterface } from './tenant-admin-account.interface';
import { NecTenantAdminAuthCodeService } from './tenant-admin-auth-code.service';

let authCode = '';
let lsUserInfo = null;
let lsToken = null;
@Component({
  selector: 'nec-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class NecHeaderComponent implements OnInit {
  /**
   * ä¸çº§ç®å½åè¡¨
   */
  @Input() menus: HeaderMenu[];
  /**
   * å³ä¾§ç¨æ·åä¸æåè¡¨
   */
  @Input() dropdownMenus: HeaderDropdownMenu[];
  /**
   * æçæå­¦ä¸æèå
   */
  @Input() myTeachingLeftMenus: HeaderMenu[] = [];

  @Input() myTeachingRightMenus: HeaderMenu[] = [];
  /**
   * å¬å±èµæºåºä¸æèå
   */
  @Input() resourceMenus: HeaderMenu[];
  /**
   * å¸®å©ä¸­å¿
   */
  @Input() helpCenter: HeaderDropdownMenu[] = [];

  /**
   * ä¸å¡è·¯å¾çåç¼, é»è®¤å½åè·¯ç±çååé¨å
   * ç®ååªæmgtç«¯ä½¿ç¨, ç¨äºè·³è½¬åexamç«¯
   * ä¾: https://dev.512ks.cn
   */
  @Input() prefixUrl = '';
  /**
   * æ¯å¦å·²ç»é, ç¨äºåºåä¸åæåµä¸çæ¾ç¤º
   */
  logged: boolean;
  /**
   * çå®å§å/ç¨æ·å
   */
  username: string;
  /**
   * ç¨æ·å¤´åå°å
   */
  avatarUrl: string;
  /**
   * ç¨æ·æå±æé
   */
  authority: AuthorityType;
  /**
   * ç¨æ·æéåè¡¨
   */
  AUTHORITY_TYPE = AuthorityType;
  /**
   * ç§æ·logoå¾çå°å
   */
  tenantLogoUrl: string;
  /**
   * ç¨æ·æ¯å¦å·²è®¤è¯ï¼å½±åæ¯å¦æ¾ç¤ºä¸äºæé®ï¼
   */
  isCertified: boolean;
  /**
   * æ§å¶ å¤´å-ç¨æ·å åºåçä¸æåè¡¨æ¯å¦æ¾ç¤º
   */
  showDropdown = false;
  /**
   * æ§å¶æçæå­¦ä¸æèåæ¯å¦æ¾ç¤º
   */
  showMyTeachingDropdown = false;
  /**
   * æ§å¶å¬å±èµæºåºä¸æèåæ¯å¦æ¾ç¤º
   */
  showReasourceDropdown: boolean;

  /**
   * è®°å½æ¯å¦æ¯å»çäºåå¯ç»å½
   */
  isHCloudLogin = false;

  /**
   * è·³è½¬è¶ç®¡é¡µé¢æé
   */
  hasTenantAdminAuth: boolean = false;

  /**
   * è¿åèªå·±é¡µé¢æé
   */
  hasBackSelfAuth: boolean = false;

  constructor(
    private authService: NecAuthService,
    private headerService: HeaderService,
    private router: Router,
    private userService: UserService,
    private dictDataService: NecDictDataService,
    private tenantAdminAccountInterface: NecTenantAdminAccountInterface,
    private tenantAdminAuthCodeService: NecTenantAdminAuthCodeService,
    private ls: NecLocalStorageService,
    private toast: NecToast
  ) {
    this.isHCloudLogin = this.headerService.isHCloudLogin;
  }

  ngOnInit() {
    // æ´æ°ç¸å³ä¿¡æ¯
    this.update();

    this.getHasTenantAdminAuth(this.userService.getUserInfo());

    // è®¢éæ´æ°ä¿¡æ¯çå¨æ
    this.headerService.updateInfo$
      .subscribe(() => {
        setTimeout(() => {
          this.update();
        }, 500);
      });

    // è®¢éæ´æ°éä¸­ç®å½çå¨æ
    this.headerService.updateActiveModule$
      .subscribe(module => {
        this.updateActiveModule(module);
      });
  }

  /**
   * è¿åä¸»é¡µï¼ç®åè·³è½¬åexamï¼
   */
  goHome() {
    if (!this.prefixUrl) {
      this.router.navigate(['/home']);
    }
    else {
      window.location.href = this.prefixUrl + '/home';
    }
  }

  /**
   * ä¸çº§ç®å½/ä¸æèåç¹å»åè·³è½¬
   */
  goToMenu(menu: HeaderMenu) {
    // todo why so tricky...
    if (menu.path.indexOf('archive') >= 0) {
      this.updateActiveModule(menu.text);
      this.router.navigate([menu.path, 'dept:-1', this.userService.getUserInfo().position.userId, 1]);
    }
    else if (this.prefixUrl && menu.isAngularJs) {
      this.updateActiveModule(menu.text);
      window.location.href = this.prefixUrl + menu.path;
    }
    else {
      this.router.navigate([menu.path]).then(success => {
        if (success) {
          this.updateActiveModule(menu.text);
        }
      });
    }
  }

  /**
   * æçæå­¦ä¸æèåï¼ç¹å»åè·³è½¬
   */
  myTeachingGoToMenu(event: Event, menu: HeaderMenu) {
    window.location.href = this.prefixUrl + menu.path;
    event.stopPropagation();
  }

  /**
   * å¬å±èµæºåºä¸æèåï¼ç¹å»åè·³è½¬
   */
  resourceGoToMenu(event: Event, menu: HeaderMenu) {
    if (menu.path) {
      this.router.navigate([menu.path]);
    }
    event.stopPropagation();
  }

  /**
   * ç»åº
   */
  logout(callBack?: any) {
    // æ¸çç¸å³æ°æ®
    this.showMyTeachingDropdown = false;
    this.showDropdown = false;
    this.authService.logout();
    this.userService.delUserInfo();
    this.dictDataService.delAllDictData();
    this.ls.del('hasTenantAdminAuth');
    this.logged = false;
    this.menus.forEach(menu => menu.active = false);
    this.tenantAdminAuthCodeService.deleteTenantAdminAuthInfo();

    if (this.isHCloudLogin) {
      setTimeout(() => {
        window.location.href = this.headerService.hCloudLoginParam.authUrl;
      }, 500);
    } else if (!this.prefixUrl) {
      this.router.navigate(['/login']);
    } else {
      if (callBack) {
        callBack();
      }
      setTimeout(() => {
        window.location.href = this.prefixUrl + '/login';
      }, 500);
    }
  }

  /**
   * æ´æ°æ¾ç¤ºçä¿¡æ¯
   */
  update() {
    this.logged = this.authService.authenticate();
    this.authority = this.userService.getAuthority();
    this.tenantLogoUrl = this.userService.getTenantLogoUrl();
    this.username = this.userService.getRealName();
    this.avatarUrl = this.userService.getAvatarUrl();
    this.isCertified = this.userService.getIsCerified();

    this.headerService.calcMenuShowOrNot(this.menus, this.authority, this.isCertified);
    this.headerService.calcMenuShowOrNot(this.dropdownMenus, this.authority, this.isCertified);
  }

  /**
   * æ´æ°ä¸çº§èåéä¸­ç¶æ
   */
  updateActiveModule(module: string) {
    this.menus.forEach(menu => menu.active = menu.text === module);
    if (module === 'manage') {
      this.menus.forEach(menu => {
        if (menu.path.indexOf('tenant') > -1) {
          menu.active = true;
        }
      });
    }
  }

  showDropDown(menu: HeaderMenu) {
    if (menu.text === 'æçæå­¦') {
      this.showMyTeachingDropdown = true;
      this.showReasourceDropdown = false;
    } else if (menu.text === 'å¬å±èµæºåº') {
      this.showMyTeachingDropdown = false;
      this.showReasourceDropdown = true;
    }
  }

  clearShowDropDownState() {
    this.showMyTeachingDropdown = false;
    this.showReasourceDropdown = false;
  }

  private initAuthParmas() {
    this.hasBackSelfAuth = false;
    this.hasTenantAdminAuth = false;
    authCode = '';
    lsUserInfo = null;
    lsToken = null;
  }

  // è·åç¨æ·æ¯å¦æ å»é¢è¶ç®¡æé æ è¿åèªå·±é¡µé¢æé
  private getHasTenantAdminAuth(userInfo) {
    this.initAuthParmas();
    if (!userInfo || !this.authService.authenticate()) {
      return;
    }
    if (userInfo.account.authorities[0].authority !== 'ROLE_TENANT') {
      this.tenantAdminAuthCodeService.deleteTenantAdminAuthInfo();
      if (userInfo && userInfo.account && userInfo.tenant) {
        this.tenantAdminAccountInterface.existsUserAccount(userInfo.account.id, userInfo.tenant.id).subscribe((res) => {
          this.hasTenantAdminAuth = res;
          this.ls.set('hasTenantAdminAuth', res);
        })
      }
    } else if (userInfo.account.authorities[0].authority === 'ROLE_TENANT') {
      this.hasBackSelfAuth = this.tenantAdminAuthCodeService.getTenantAdminAuthInfo() ? true : false;
    }
  }

  go2TenantAdmin() {
    let userInfo = this.userService.getUserInfo();
    this.tenantAdminAccountInterface.getAuthCodeByUserAccountId(userInfo.account.id, userInfo.tenant.id).subscribe((res) => {
      authCode = res;
      lsUserInfo = this.ls.get('userInfo');
      lsToken = this.ls.get('token');
      if (authCode && lsUserInfo && lsToken) {
        this.logout(() => {
          this.tenantAdminAuthCodeService.setTenantAdminAuthInfo({
            authCode: authCode,
            userInfo: lsUserInfo,
            token: lsToken
          })
        });
      }
    }, (err) => {
      if (err.data.message === 'å½åè´¦æ·æªææ') {
        this.hasTenantAdminAuth = false;
        this.toast.warning(err.data.message);
      }
    })
  }

  go2Self() {
    let selfInfo = this.tenantAdminAuthCodeService.getTenantAdminAuthInfo();
    if (selfInfo && selfInfo.token && selfInfo.userInfo) {
      this.logout(() => {
        this.authService.setToken(selfInfo.token);
        this.userService.setUserInfo(selfInfo.userInfo);
      });
    } else {
      this.hasBackSelfAuth = false;
      this.tenantAdminAuthCodeService.deleteTenantAdminAuthInfo();
    }
  }


  go2YuQue() {
    window.open("https://www.yuque.com/512ks");
  }
}
